import { formatPrice } from '@apm/i18n';

import type { ItemBrief } from '../../home/compose-home.js';
import { useLocale, useT } from '../../i18n/LocaleProvider.js';
import { revealOnFocus } from './labels.js';

/**
 * 「지금 판매 중」의 상품 카드. **네이티브 `<button>`** (절대 규칙 29).
 *
 * OK → 그 상품부터 재생 — v11 선택 구매의 그 경로(`useReceiver` 의 `pendingStart.kind ===
 * 'select'` → `selectItem`). 홈은 `productId` 하나를 `ChannelGate` 의 `startAt` 으로 넘길 뿐이다.
 * 가격은 `@apm/i18n` 의 `formatPrice` — 전체 상품 시트와 같은 함수다.
 */
export function ItemCard({
  item,
  onPick,
}: {
  item: ItemBrief;
  onPick: (productId: string) => void;
}) {
  const t = useT();
  const { locale } = useLocale();
  return (
    <button
      type="button"
      className="home__card home__card--item"
      data-testid="home-card-item"
      data-product-id={item.productId}
      onFocus={revealOnFocus}
      onClick={() => {
        onPick(item.productId);
      }}
    >
      <img className="home__card-art" src={item.thumbnailUrl} alt="" loading="lazy" />
      <span className="home__card-body">
        <span className="home__card-title" data-i18n="data">
          {item.title}
        </span>
        {item.price !== null && (
          <span className="home__card-price" data-i18n="data">
            {formatPrice(item.price, locale)}
          </span>
        )}
        <span className="home__card-meta">{t('epg.entryPoint')}</span>
      </span>
    </button>
  );
}
